import PetsListItem from "./PetsListItem";

export default PetsListItem;
